
import React, { useEffect } from "react";
import styled from 'styled-components';
import Footer from "../../components/common/Footer";
import Header from "../../components/common/header/Header";
import { reqEsItemAction } from '../../modules/es/esItemModule';
import { reqEsDetailInfoAction } from '../../modules/od/orderModule';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import Modal from 'react-modal';
import EsReqInfoPopup, { EsReqInfoPopupModalStyles } from '../../components/es/EsReqInfoPopup';
import EsOrderDonePopup, { EsOrderDonePopupModalStyles } from '../../components/es/EsOrderDonePopup';
import EsReqStopPopup, { EsReqStopPopupModalStyles } from '../../components/es/EsReqStopPopup';
import EsReqDonePopup, { EsReqDonePopupModalStyles } from '../../components/es/EsReqDonePopup';
import {isMobileOnly} from 'react-device-detect';
import EsReqPriceInfo from '../../components/es/EsReqPriceInfo';
import EsReqProductInfo from '../../components/es/EsReqProductInfo';
import EsReqConfirmInfo from '../../components/es/EsReqConfirmInfo';
import EsReqEsInfo from '../../components/es/EsReqEsInfo';
import EsReqDeliveryAddInfo from '../../components/es/EsReqDeliveryAddInfo';
import EsReqRefundInfo from '../../components/es/EsReqRefundInfo';
import { delEsItemAction, updateEsItemStatusAction } from '../../modules/es/esItemModule';
import NormalPopup, { customModalStyles } from '../../components/common/popup/NormalPopup';

/**
 * 견적 정보 화면
 */
const EstimateInfoViewBlock = styled.div`
    
`;

const EstimatInfoViewMobileBlock = styled.div`
    ${isMobileOnly?`
        margin: 0 4vw;
        `:`
        width: 100%;
        margin: 0 auto;
        `};
        padding-bottom: 30px;

    .header-block {
        width: 100vw;
        
        height: 50px;
        margin: 0 0 10px;
        //padding: 7px 125px 7px 2px;
        background-color: #ffffff;
        position: fixed;
        top: 0;
        z-index: 10;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        color: #111111;
        line-height: 50px;
        margin-left: -4vw;

        .back {
            width: 36px;
            height: 36px;
            position: absolute;
            top: 7px;
            left: 2px;
            background: url(/assets/images/icon/back_btn.svg) center center/auto no-repeat;
        }
    }

    .brand-name {
        font-size: 18px;
        font-weight: 500;
        line-height: 1.44;
        color: #111111;
        margin-top: 60px;
    }
`;

const HeaderGrayLine = styled.div`
    height: 8px;
    width: 100vw;
    margin-left: -4vw;
    background-color: #ececec;
    border-top: 1px solid #e0e0e0;
`;

const BottomBlock = styled.div`
    .info {
        font-size: 14px;
        font-weight: normal;
        line-height: 1.57;
        text-align: center;
        color: #333333;
    }

    .confirm {
        font-size: 12px;
        font-weight: normal;
        line-height: 1.83;
        text-align: center;
        color: #333333;
    }

    .button-container {
        text-align: center;
        .button {
            padding: 11px 40px 10px;
            border-radius: 20px;
            background-color: #ececec;
            font-size: 13px;
            font-weight: normal;
            line-height: 1.54;
            text-align: center;
            color: #333333;
        }
    }
`;

const OrderBlock = styled.button`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 70px;
    //padding: 18px 20px;
    background-color: #ffc742;
    text-align: center;
    z-index: 1;
    box-shadow: 3px 0 6px 0 rgba(0, 0, 0, 0.16);
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    text-align: center;
    color: #111111;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
`;

const BlankBlock = styled.div`
    height: 60px;
    width: 100%;
`;
const EstimateInfoView = ({ location }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [openModal, setOpenModal] = useState(false);
    const [esItem, setEsItem] = useState(null);
    const [rqst_status, setRqstStatus] = useState(null);
    const [openModalMobile, setOpenModalMobile] = useState(false);
    const [msg, setMsg] = useState(null);

    const { esItemInfo, esItemInfoRes, accessToken, curMenu , esItemDetailInfo, esStatusRes} = useSelector(
        ({ userReducer, esItemsReducer, headerReducer, esOrderReducer }) => ({
            accessToken: userReducer.accessToken,
            esItemInfoRes: esItemsReducer.esItemInfoRes,
            esItemInfo: esItemsReducer.esItemInfo,
            curMenu: headerReducer.curMenu,
            esItemDetailInfo: esOrderReducer.esItemDetailInfo,
            esStatusRes: esItemsReducer.esStatusRes,
        })
    );

    useEffect(() => {
        dispatch(reqEsItemAction(location.search));
    }, [location])


    useEffect(() => {
        if(esItemInfo !== null){
            //console.log('esItemInfo = ' + JSON.stringify(esItemInfo));
            setEsItem(esItemInfo.items);
            setRqstStatus(esItemInfo.items[0].rqst_status);
            setOpenModal(true);
            dispatch(reqEsDetailInfoAction(esItemInfo.items[0].es_rqst_id))
        }
    }, [esItemInfo])

    useEffect(() => {
        //console.log('esStatusRes = ' + JSON.stringify(esStatusRes));
        if(isMobileOnly && esStatusRes !== null && esStatusRes*1 ===200) {
            //console.log('esStatusRes222 = ' + JSON.stringify(esStatusRes));
            
            history.replace('/es');
            //onCloseClick();
        }
    }, [esStatusRes])

    const getModalComp = () => {
        if (rqst_status === '050105' || rqst_status === '050111') {
            return (<EsReqDonePopup esItem={esItem}
                onCloseClick={() => { setOpenModal(false); handleBack(); }} />)
        } else if (rqst_status === '050106') {
            return (<EsOrderDonePopup esItem={esItem} od_id={esItem[0].od_id}
                onCloseClick={() => { setOpenModal(false); handleBack(); }} />
            )
        } else if (rqst_status === '050108') { //견적중단
            return (<EsReqStopPopup esItem={esItem}
                onCloseClick={() => { setOpenModal(false); handleBack(); }} />
            )
        } else {
            return (<EsReqInfoPopup esItem={esItem}
                onCloseClick={() => { setOpenModal(false); handleBack(); }} />)
        }
    }

    const getModalStyle = () => {
        if (rqst_status === '050105') {
            return EsReqDonePopupModalStyles;
        } else if (rqst_status === '050106') {
            return EsOrderDonePopupModalStyles;
        } else if (rqst_status === '050108') { //견적중단
            return EsReqStopPopupModalStyles;
        } else {
            return EsReqInfoPopupModalStyles;
        }
    }

    const onCloseModal = () => {
        setOpenModal(false);
        handleBack();
    }

    const handleBack = () => {
        history.goBack();
    }

    const handleSubmit = () => {
        if(esItem[0].dday >= 0){
            history.push("/order?reqid=" + esItem[0].es_rqst_id);
        }
    }

    const handleModalClose = () => {
        setOpenModalMobile(false);
    }

    // 확인
    const handleModalBtn1Click = () => {
        if(rqst_status === '050102') {
            dispatch(updateEsItemStatusAction(esItem[0].es_rqst_id,"050110")); //050110 -> 견적취소
        }
    }

    // 닫기
    const handleModalBtn2Click = () => {
        setOpenModalMobile(false);
    }

    const handleClickCancelBtn = () => {
        setMsg("견적서가 취소됩니다.\n견적취소하시겠습니까?");
        setOpenModalMobile(true);
    }

    const validGrayLine = () => {
        if(rqst_status === '050108'|| rqst_status === '050110') {
            return false;
        }
        return true;
    }

    const validConfirm = () => {
        if(rqst_status === '050105' || rqst_status === '050111' || rqst_status === '050107' ) {
            return true;
        }
        return false;
    }

    const validRefund = () => {
        if(rqst_status === '050105' || rqst_status === '050111' || rqst_status === '050107') {
            return true;
        }
        return false;
    }

    const validOrder = () => {
        if(rqst_status === '050105' && esItem[0].dday >= 0) {
            return true;
        }

        return false;
    }
    const getBottom = () => {
        if(rqst_status === '050101' || rqst_status === '050103') {
            return (
                <BottomBlock>
                    <div className="info margin_b-10">견적 요청 시 중간 수정이 불가합니다.</div>
                    <div className="confirm margin_b-30">위 내용을 확인했습니다.</div>
                </BottomBlock>
            )
        } else if(rqst_status === '050102') {
            return (
                <BottomBlock>
                    <div className="info margin_b-10">견적 요청 시 중간 수정이 불가합니다.</div>
                    <div className="confirm margin_b-30">위 내용을 확인했습니다.</div>
                    <div className="button-container"><button className="button" onClick={handleClickCancelBtn}>견적 취소</button></div>
                </BottomBlock>
            )
        } else if(rqst_status === '050104') {
            return (
                <BottomBlock>
                    <div className="info margin_b-10">견적 진행 시 중간 수정이 불가합니다.</div>
                    <div className="confirm margin_b-30">위 내용을 확인했습니다.</div>
                </BottomBlock>
            )
        }
    }

    const getMoveIconBottom = () => {
        if(rqst_status === '050105' && esItem[0].dday >= 0) {
            return "80px";
        }

        return "10px";
    }

    if(isMobileOnly&&esItem===null) {
        return <div/>
    }

    return (isMobileOnly?
        <EstimateInfoViewBlock>
            <EstimatInfoViewMobileBlock className="margin_b-30">
                <div className="header-block">
                    <button className="back" onClick={handleBack} />
                    견적서
                </div>
                <div className="brand-name margin_b-10">From. {esItem[0].brnd_han}</div>
                <EsReqPriceInfo esItem={esItem}></EsReqPriceInfo>
                <HeaderGrayLine className="margin_t-30 margin_b-30"/>
                <EsReqProductInfo esItem={esItem}></EsReqProductInfo>
                {
                    validConfirm()&&<EsReqConfirmInfo detailInfo={esItemDetailInfo}></EsReqConfirmInfo>
                }
                <HeaderGrayLine className="margin_t-30 margin_b-30"/>
                <EsReqEsInfo esItemDetailInfo={esItemDetailInfo} esItem={esItem}></EsReqEsInfo>
                <HeaderGrayLine className="margin_t-30 margin_b-30"/>
                <EsReqDeliveryAddInfo detailInfo={esItemDetailInfo} esItem={esItem}></EsReqDeliveryAddInfo>
                {validGrayLine()&&<HeaderGrayLine className="margin_t-30 margin_b-30"/>}
                {
                    validRefund()&&<EsReqRefundInfo detailInfo={esItemDetailInfo}></EsReqRefundInfo>
                }
                {
                    getBottom()
                }
                {
                    validOrder()&&<OrderBlock onClick={handleSubmit}>주문하기</OrderBlock>
                }
            </EstimatInfoViewMobileBlock >
            <Footer siteMovePosition={getMoveIconBottom()}/>
            {validOrder()&&<BlankBlock></BlankBlock>}
            <Modal
                isOpen={openModalMobile}
                onRequestClose={handleModalClose}
                style={customModalStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {
                    <NormalPopup
                        text=""
                        text2={msg}
                        btn1="예" btn2="아니오"
                        onClick1={handleModalBtn1Click}
                        onClick2={handleModalBtn2Click} />
                }

            </Modal>
        </EstimateInfoViewBlock>
        :
        <EstimateInfoViewBlock>
            {/* <Header />
            
            <Footer /> */}
            <Modal
                isOpen={openModal}
                onRequestClose={onCloseModal}
                style={getModalStyle()}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {getModalComp()}
            </Modal>
        </EstimateInfoViewBlock>
    );
};

export default EstimateInfoView;
